import React from 'react'

import { View, Flex, Placeholder } from '@aws-amplify/ui-react'

import { MainTitle } from '../Common'


/** Skeleton placeholder shown while VPN data is loading */
export function VpnsSkeleton() {
  return (
    <View>
      <View id="your-vpns">
        <MainTitle>Your Vpns</MainTitle>
      </View>
      <Flex direction="column" gap="1rem" padding="1rem">
        <Placeholder height="2.5rem" />
        <Placeholder height="2rem" />
        <Placeholder height="6rem" />
      </Flex>
    </View>
  )
}

